import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CookiesStorage } from '@ltvco/refresh-lib';
import {
  FirstRecordSearch,
  getFirstRecordSearch,
} from '@ltvco/refresh-lib/utils';
import { AppConfig, usePermissions } from '@ltvco/refresh-lib/ctx';
import { getFreemiumSubscribePageData } from '../utils/freemiumSubscribePageStorage';

const buildReportRoute = (
  firstRecordSearchData: FirstRecordSearch,
): string | null => {
  let queryParams = '';

  if (firstRecordSearchData.searchType === 'vehicle') {
    if (stringExistsAndItsValueIsNotUndefined(firstRecordSearchData.vin)) {
      queryParams = `vin=${firstRecordSearchData.vin}`;
    } else if (
      stringExistsAndItsValueIsNotUndefined(
        firstRecordSearchData.license_plate,
      ) &&
      stringExistsAndItsValueIsNotUndefined(firstRecordSearchData.state)
    ) {
      queryParams = `license_plate=${firstRecordSearchData.license_plate}&state=${firstRecordSearchData.state}`;
    } else if (
      stringExistsAndItsValueIsNotUndefined(firstRecordSearchData.make) &&
      stringExistsAndItsValueIsNotUndefined(firstRecordSearchData.model) &&
      stringExistsAndItsValueIsNotUndefined(firstRecordSearchData.year)
    ) {
      queryParams = `make=${firstRecordSearchData.make}&model=${firstRecordSearchData.model}&year=${firstRecordSearchData.year}`;
    }
  }

  return `/report/${firstRecordSearchData.searchType}?${queryParams}`;
};

function stringExistsAndItsValueIsNotUndefined(input?: string) {
  return !!input && input !== 'undefined';
}

export const useFirstRecordSearch = (account: unknown) => {
  const navigate = useNavigate();
  const cookieStorage = new CookiesStorage();
  const { isFreePlan } = usePermissions();
  const { logError } = useContext(AppConfig);

  const freemiumSubscribePageData = getFreemiumSubscribePageData();
  const comesFromSkipSubscribePageFlow = freemiumSubscribePageData.skip_page;

  // Gate: route to Subscribe if user is freemium and hasn’t skipped, and a first record search exists
  useEffect(() => {
    if (!account) return;

    const firstRecordSearchData = getFirstRecordSearch();

    const hasSkippedSubscribePage =
      (account as any)?.account?.user_settings?.hide_freemium_upgrade_prompt ===
      true;

    if (
      isFreePlan &&
      !hasSkippedSubscribePage &&
      !comesFromSkipSubscribePageFlow
    ) {
      navigate('/subscribe');
    }
  }, [account, navigate]);

  // Continue flow: after upgrade or skip, redirect to the report and remove cookie
  useEffect(() => {
    if (!account) return;

    const firstRecordSearchData = getFirstRecordSearch();

    const hasSkippedSubscribePage =
      (account as any)?.account?.user_settings?.hide_freemium_upgrade_prompt ===
      true;

    if (
      (!isFreePlan ||
        hasSkippedSubscribePage ||
        comesFromSkipSubscribePageFlow) &&
      firstRecordSearchData
    ) {
      const navigateTo = buildReportRoute(
        firstRecordSearchData as FirstRecordSearch,
      );
      if (navigateTo) {
        navigate(navigateTo);
        cookieStorage.removeValue('first_record_search');
      }
    }
  }, [account, navigate]);
};
